import React, { useEffect, useState } from "react";
import { IoIosLock } from "react-icons/io";
import { MdLockOutline } from "react-icons/md";
// import CrossIcon from "../../../../assets/icons/cross-icon.svg";

interface EventMarketButtonProps {
  mainValue?: any;
  mainValueClass?: "price" | "runs";
  subValue?: number | null;
  subValueClass?: "size" | "odds";
  disable?: boolean;
  oddType:
    | "back-odd"
    | "lay-odd"
    | "odds-yes-cell"
    | "odds-no-cell"
    | "premium-odd";
  valueType?:
    | "matchOdds"
    | "bookmakerOdds"
    | "fancyMarketOdds"
    | "binaryOdds"
    | "premiumOdds";
  onClick?: () => void;
  oddsSet?: number[] | null;
  showSubValueinKformat?: boolean;
  customBgColor?: string;
  hideVolume?: boolean;
  customBorder?: string;
  /** The cell the open bet slip was opened from — Sky paints it dark with white text. */
  selected?: boolean;
}

const EventMarketButton: React.FC<EventMarketButtonProps> = (props) => {
  const {
    mainValue,
    // mainValueClass,
    subValue,
    // subValueClass,
    disable,
    oddType,
    valueType,
    onClick,
    oddsSet,
    customBgColor,
    showSubValueinKformat,
    hideVolume,
    customBorder,
    selected = false,
  } = props;
  const [currentValue, setCurrentValue] = useState<number | null>(null);
  const [classes, setClasses] = useState<string>("exch-odd-button");
  const [timer, setTimer] = useState<number | null>(null);
  const [currentOdds, setCurrentOdds] = useState<number[]>([]);
  const [volume, setVolume] = useState<number>();
  const subValprecision: number = valueType === "matchOdds" ? 0 : 0;

  useEffect(() => {
    if (subValue) {
      if (valueType === "matchOdds") setVolume(subValue * 1000);
      else setVolume(subValue);
    }
  }, [subValue, valueType]);

  const oddValueChanged = () => {
    if (timer) {
      clearTimeout(timer);
    }

    const chVal = mainValue;
    if (chVal) {
      const cVal = currentValue;
      setCurrentValue(chVal);
      let showAnimation = true;
      if (oddsSet && oddsSet.length > 0) {
        showAnimation = !currentOdds.includes(chVal);
        setCurrentOdds(oddsSet);
      }
      if (showAnimation) {
        if (cVal && chVal !== cVal) {
          if (!classes.includes("odd-change"))
            setClasses(classes + " odd-change");
          setTimer(
            setTimeout(
              () => setClasses(classes.replace(" odd-change", "")),
              5000
            ) as unknown as number
          );
        }
      }
    }
  };

  useEffect(() => {
    oddValueChanged();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mainValue, subValue]);

  const getOddDisplayNum  = () => {
    if (mainValue)
      return Number.isNaN(Number(mainValue)) ? (
        <br />
      ) : valueType === "fancyMarketOdds" ? (
        Number(mainValue)
      ) : valueType === "matchOdds" ? (
        Number(mainValue).toFixed(2)
      ) : (
        (() => {
          const fixed = Number(mainValue).toFixed(2);
          // If the fixed value ends with .00, return only the integer part
          return fixed.endsWith(".00") ? fixed.split(".")[0] : fixed;
        })()
      );
  };

  const isLaySide = oddType === "lay-odd" || oddType === "odds-no-cell";
  const pinkOrBlueColor = selected
    ? isLaySide
      ? "bg-slipLaySelected"
      : "bg-slipBackSelected"
    : oddType === "lay-odd"
      ? "bg-pink1"
      : "bg-blue13";
    const disabledBgColor =
    oddType === "lay-odd" || oddType === "odds-no-cell"
      ? "bg-pink1 opacity-50"
      : "bg-blue13 opacity-50";

  return (
    <>
      {mainValue && Number(mainValue) > 0 ? (
        <div
          className={`w-full h-full ${
            disable ? disabledBgColor : ""
          } ${classes} cursor-pointer flex justify-center items-center  
              text-white ${selected ? pinkOrBlueColor : customBgColor || pinkOrBlueColor}`}
          onClick={() => (!disable ? onClick?.() : {})}
        >
          <div
            className={`flex flex-col justify-center items-center gap-1 ${
              oddType === "premium-odd" ? "h-full" : ""
            } ${customBorder} `}
          >
            <div className={`text-[12px] leading-[15px] font-[700] ${selected ? "text-white" : "text-[#1e1e1e]"}`}>
              {getOddDisplayNum()}
            </div>

            {oddType !== "premium-odd" &&
            valueType !== "bookmakerOdds" &&
            !hideVolume ? (
              <div className={`text-[11px] font-normal leading-none ${selected ? "text-white" : "text-[#1e1e1e]"}`}>
                {volume
                  ? showSubValueinKformat && Number(volume > 999)
                    ? Number(volume / 1000).toFixed(subValprecision) + "K"
                    : Number(volume).toFixed(subValprecision)
                  : "0.00K"}
              </div>
            ) : null}
          </div>
        </div>
      ) : (
        <div
          className={`w-full h-full flex justify-center items-center disabled opacity-60 ${
            customBgColor || pinkOrBlueColor
          } ${classes}`}
        >
          {
            valueType === "bookmakerOdds" ? (
              ""
            ): (
              <MdLockOutline className="h-3.5 w-3.5 md:h-4 md:w-4" />
            )
          }
        </div>
      )}
    </>
  );
};
export default EventMarketButton;
